import React from 'react';
import Accent from '@/components/typography/Accent';
import Paragraph from '@/components/typography/Paragraph';

const Testing = () => (
  <>
    <Paragraph>
      Unit and integration tests have been part of my development process for
      the last 4 years.
    </Paragraph>
    <Paragraph>
      100% test coverage is not my ultimate goal and wanting to cover every
      single statement, branch or line of code will ultimately make you start
      testing implementation details to get the satisfaction of a number. I want
      my tests to give me the confidence that my components work for the users
      as expected.
    </Paragraph>
    <Paragraph>
      It's the reason why I particularly like the react-testing-library by Kent
      C. Dodds which has been designed keeping this in mind
      <Accent>
        {' '}
        'The more your tests resemble the way your software is used, the more
        confidence they can give you.'
      </Accent>
    </Paragraph>
    <Paragraph>
      I am convince of the interest of TDD and even if it still not a systematic
      in my current approach I am willing to enforce it.
    </Paragraph>
  </>
);

Testing.propTypes = {};

export default Testing;
